import React from 'react';
import { useStore, useActions } from '../../hooks/useStore';
import { useImageLibraryStore } from '../../state/createImageLibraryStore';
import WatchOrderModal from './WatchOrderModal';
import type { PartyMember, Image } from '../../types/types';

interface WatchOrderModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for WatchOrderModal (ADR-034).
 * Owns store access for party roster, watch order, image library,
 * and the updateWatchOrder action.
 */
const WatchOrderModalContainer: React.FC<WatchOrderModalContainerProps> = ({ isOpen, onClose }) => {
  const partyRoster: PartyMember[] = useStore(state => state.session?.roster?.partyRoster) || [];
  const generalState = useStore(state => state.session?.general);
  const watchOrder = ((generalState?.campWatchOrder || []) ?? []).map(Number);
  const imageLibrary: Image[] = useImageLibraryStore(state => state.images);
  const actions = useActions();

  const handleUpdateWatchOrder = (newOrder: number[]) => {
    actions.updateWatchOrder(newOrder);
  };

  return (
    <WatchOrderModal
      isOpen={isOpen}
      onClose={onClose}
      partyRoster={partyRoster}
      watchOrder={watchOrder}
      imageLibrary={imageLibrary}
      onUpdateWatchOrder={handleUpdateWatchOrder}
    />
  );
};

export default WatchOrderModalContainer;
